export default __webpack_public_path__ + "static/media/voxDay.d7cfa94e.png";